import {
    Box,
    Card,
    Container,
    Grid,
    InputAdornment,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { Editor } from '@tinymce/tinymce-react';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import {
    useCreateListDataMutation,
    useGetListDataQuery,
} from '../../../api/apiSlice';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import Form from '../../../components/utilities/Form';
import errorSnackbar from '../../../utils/errorSnackbar';

const validate = Yup.object().shape({
    dob: Yup.string().required().label('DOB'),
    phoneNumber: Yup.string().required().min(9).max(10).label('Phone Number'),
});

export default function Update({ handleNext, setActiveStepAs }) {
    const [edBio, setEdBio] = useState('');
    const [search, setSearch] = useState('');
    const [resultLocation, setResultLocation] = useState(null);
    const [locationSelected, setLocationSelected] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const state = useSelector((st) => st);
    const { user } = state.auth;

    const [registerMinister, { isLoading: isRegisterLoading }] =
        useCreateListDataMutation();

    const { data: searchPlacesData } = useGetListDataQuery(
        { list: 'church/finder', params: { q: search } },
        { refetchOnMountOrArgChange: true }
    );

    const searchPlaces = searchPlacesData?.data;

    useEffect(() => {
        localStorage.getItem(`minister_signup_${user?.username}`) &&
            setActiveStepAs(1);
    }, [setActiveStepAs, user?.username]);

    return (
        <Container maxWidth="sm">
            <Box sx={{ my: 1 }}>
                <Typography className="fw-bold">
                    Hi {user?.firstName}
                </Typography>
                <Typography>
                    Welcome on board, please update your profile information to
                    get started
                </Typography>
            </Box>
            <Form
                onSubmit={async (vals) => {
                    const setRegStatus = () =>
                        localStorage.setItem(
                            `minister_signup_${user?.username}`,
                            'true'
                        );

                    const fieldVals = {
                        ...vals,
                        dob: vals.dob?.replaceAll('-', '/'),
                        lat: resultLocation?.lat,
                        long: resultLocation?.lng,
                        bio: edBio,
                        mpesa_no: '0' + vals.phoneNumber,
                    };

                    if (!locationSelected) {
                        enqueueSnackbar('Please select a location', {
                            variant: 'error',
                        });
                        return;
                    }

                    const { data, error } = await registerMinister({
                        list: '/pastors',
                        body: fieldVals,
                    });

                    errorSnackbar(error, enqueueSnackbar);

                    if (error?.data?.message?.includes('already')) {
                        setRegStatus();
                        handleNext(fieldVals);
                    }

                    if (data) {
                        setRegStatus();
                        enqueueSnackbar('Registration Success');
                        handleNext(fieldVals);
                    }
                }}
                validationSchema={validate}
                initialValues={{ dob: '', phoneNumber: '' }}
            >
                <FormikInput
                    type="date"
                    name="dob"
                    label="DOB"
                    placeholder="DOB"
                />
                <FormikInput
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                +254
                            </InputAdornment>
                        ),
                    }}
                    name="phoneNumber"
                    label="Phone Number"
                    placeholder="7XXXXXXXX"
                />
                <Typography sx={{ mx: 1, mb: 0.5 }}>Bio</Typography>
                <Editor
                    apiKey="wk87szosn5rjqu90ub5t313n25a9gx9x6dnfaav2sdoobb88"
                    onEditorChange={(html) => setEdBio(html)}
                    value={edBio}
                    cloudChannel="6-dev"
                    init={{}}
                />
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Your Location"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ my: 1 }}
                />
                {searchPlaces?.map(({ address, location }) => (
                    <Grid
                        item
                        xs={12}
                        key={address}
                        onClick={() => {
                            setLocationSelected(true);
                            setSearch(address);
                            setResultLocation({
                                lat: Number(location?.latitude),
                                lng: Number(location?.longitude),
                            });
                        }}
                    >
                        <Card
                            sx={{ p: 1.5, mx: 0.8, my: 0.2 }}
                            variant="outlined"
                        >
                            <Typography variant="h6">{address}</Typography>
                        </Card>
                    </Grid>
                ))}

                <Stack direction="row" justifyContent="flex-end">
                    <FormikButton
                        loading={isRegisterLoading}
                        variant="contained"
                    >
                        Next
                    </FormikButton>
                </Stack>
            </Form>
        </Container>
    );
}
